import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  private whitelist = new Set<string>([environment.tokenKey]);

  init(): Promise<void> {
    return new Promise<void>((resolve) => {
      try {
        const current = environment.appVersion as string | undefined;
        const stored = localStorage.getItem('appVersion');
        if (current && stored !== current) {
          this.clearStorageExceptWhitelist();
          localStorage.setItem('appVersion', current);
          const reloaded = sessionStorage.getItem('appJustReloaded');
          if (!reloaded) {
            sessionStorage.setItem('appJustReloaded', '1');
            location.reload();
            return;
          }
        }
      } catch {}
      resolve();
    });
  }

  private clearStorageExceptWhitelist() {
    const localKeys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && !this.whitelist.has(k)) localKeys.push(k);
    }
    localKeys.forEach((k) => localStorage.removeItem(k));

    const sessionKeys: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k && k !== 'appJustReloaded') sessionKeys.push(k);
    }
    sessionKeys.forEach((k) => sessionStorage.removeItem(k));
  }
}
